import React from 'react';
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useSelector } from 'react-redux';
import { profileColors } from '../profileConstants';

const Smiley = ({
    size = "100px",
    margin = "0",
    profile,
    addNew = false,
    showName = true,
    isEditMode = false,
    onClick = () => { },
    pointer = true,
    focusTo = false,
    focusable = true
}) => {

    const { theme } = useSelector((state) => state.application);

    const { ref, focused, setFocus } = useFocusable({
        autoRestoreFocus: focusable,
        focusable: focusable,
        onArrowPress: (direction) => {
            if (direction === 'up' && focusTo) {
                setFocus(focusTo);
            }
            return true;
        },
        onEnterRelease: onClick
    });

    return (
        <div ref={ref} className='smiley' style={{ display: "flex", flexDirection: "column", alignItems: "center", overflow: "hidden", margin: margin, cursor: pointer ? "pointer" : "default", }} onClick={onClick}>
            <div style={{ height: size, width: size, backgroundColor: addNew ? "gray" : profileColors[profile?.Avatar ?? 0], borderRadius: "10px", display: "flex", justifyContent: "center", alignItems: "center", position: "relative", border: focused ? "4px solid white" : "4px solid transparent", }}>
                {!addNew && profile?.EnableParentalControl && <i className='fa fa-shield' style={{ color: "white", position: "absolute", top: "5px", right: "50%", transform: "translateX(50%)", fontSize: `calc( ${size} / 4 )` }} />}
                {addNew ? <i className='fa fa-plus fa-2x' /> : <img src={require("../face.png")} style={{ width: "100%" }} />}
            </div>
            {isEditMode && !addNew && <div style={{ height: size, width: size, position: "absolute", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgba(0,0,0,0.5)", borderRadius: "10px" }}>
                <i className='fa fa-pencil fa-2x' style={{ color: theme?.general?.color ?? "#ffffff", cursor: "pointer" }} />
            </div>}
            {showName && <p className='mb-0 mt-1' style={{ color: profile?.Description?.length == 0 ? "transparent" : theme?.general?.color ?? "#ffffff" }}>{addNew ? "Add Profile" : profile?.Description?.length == 0 ? "." : profile?.Description ?? ""}</p>}
        </div >
    );
}

export default Smiley;
